<template>
  <div>
    <div
      v-if="showFigure"
      class="ProgressBar-figure"
    >
      {{ roundNumber(percentage, 10) }}% complete
    </div>
    <span
      :style="{ height: height + 'px' }"
      class="ProgressBar"
    >
      <span
        :style="{ width: percentage + '%', height: height + 'px' }"
        class="ProgressBar-percentage"
      />
    </span>
  </div>
</template>

<script>
import { roundNumber } from '@/filters';

export default {
  props: {
    percentage: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 3,
    },
    showFigure: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      roundNumber,
    };
  },
};
</script>

<style lang="scss" scoped>
  @import "../../../scss/abstracts/abstracts";
  .ProgressBar {
    text-align: center;
    margin: 0;
    padding: 0;
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    border-radius: 10px;
    background: $lightgrey;
    z-index: 0;
  }

  .ProgressBar-percentage {
    display: block;
    transition: .2s;
    border-radius: 8px;
    background: $mediumgreen;
    top: 0 !important; // TODO - Hack, as nav css is so specific
  }

  .ProgressBar-figure {
    //position: absolute;
    left: 100%;
    color: color('green');
    //margin-left: spacing(sm);
    //top: 50%;
    //transform: translateY(-50%);
    font-size: rem(14px);
    //display: none;
  }
</style>
